import type { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import type { DocumentServicesObject } from '@wix/document-services-types';
import type {
  TPAHandler,
  TPAMessage,
  TPAMessageCallback,
} from '../../types/tpaMessage';
import type { TpaStyleService } from '../../services';

export function createStyleHandlers(
  platformApiMethods: PlatformApiMethods,
  _documentServicesAPI: DocumentServicesObject,
  tpaStyleService: TpaStyleService,
) {
  const createSetStyleParamHandler =
    (isGlobal: boolean): TPAHandler =>
    async (msg: TPAMessage, callback: TPAMessageCallback) => {
      const compRef = await platformApiMethods.editor.getCompRefFromCompId?.(
        msg.compId,
      );
      tpaStyleService.setStyleParam(compRef, msg.data, callback, isGlobal);
    };

  return {
    setStyleParam: createSetStyleParamHandler(false),
    setGlobalStyleParam: createSetStyleParamHandler(true),
  };
}
